import { API_END_POINTS } from './networks/apiEndPoints';
import api from './networks/api';

export const saveLiveSlot = async (payload) => {
    try {
        const response = await api.post(API_END_POINTS.SAVE_LIVE_SLOTS, payload);
        const data = response.data;

        if (data.errorCode === 200) {
            if (!data.responseData) {
                throw new Error('No SaveSlot data returned');
            }
            return data.responseData;
        } else {
            throw new Error(data.errorMessage || 'Failed to save Live slot');
        }
    } catch (error) {
        console.error('Error Saving slot:', error);
        throw error;
    }
};
